module.exports = __webpack_public_path__ + "static/media/done.44bf04e8.gif";